import { LRUCache } from "lru-cache";
import * as APITypes from "~/API";
import { MAX_CACHE_ITEMS } from "../property";
import { LoaderData } from "~/types";
import { EMPTY_RESOURCE_LIFE_ACCESS_RIGHT_INFO } from "~/services/server";

export class ResourceLifeLRUCache {
  private static cache: LRUCache<
    string,
    LoaderData<APITypes.ResourceLifeAccessRight>
  >;

  public static getCacheInstance() {
    if (ResourceLifeLRUCache.cache) {
      return ResourceLifeLRUCache.cache;
    }

    ResourceLifeLRUCache.cache = new LRUCache<
      string,
      LoaderData<APITypes.ResourceLifeAccessRight>
    >({
      max: MAX_CACHE_ITEMS,
    });
    return {
      success: true,
      data: ResourceLifeLRUCache.cache,
    };
  }

  public static get(
    key: string
  ): LoaderData<LoaderData<APITypes.ResourceLifeAccessRight>> {
    ResourceLifeLRUCache.getCacheInstance();

    const value = ResourceLifeLRUCache.cache.get(key);
    if (value === undefined) {
      return {
        success: false,
        data: {
          success: false,
          data: EMPTY_RESOURCE_LIFE_ACCESS_RIGHT_INFO,
        },
        error: new Error(`entry not found for key: ${key}`),
      };
    }

    return {
      success: true,
      data: value,
    };
  }

  public static update({
    key,
    value,
  }: {
    key: string;
    value: LoaderData<APITypes.ResourceLifeAccessRight>;
  }) {
    if (!ResourceLifeLRUCache.cache) {
      ResourceLifeLRUCache.cache = new LRUCache<
        string,
        LoaderData<APITypes.ResourceLifeAccessRight>
      >({
        max: MAX_CACHE_ITEMS,
      });
    }

    // TODO: handle the result
    const result = ResourceLifeLRUCache.cache.set(key, value);
    return {
      success: true,
      data: ResourceLifeLRUCache.cache,
    };
  }

  /**
   * Clear the entire cache or a single element in the cache
   *
   * @param key optional: the key for the element to be removed from the cache.
   * If not passed, then entire cache is cleared
   * @returns
   */
  public static clear({ key }: { key?: string }) {
    if (!ResourceLifeLRUCache.cache) {
      ResourceLifeLRUCache.cache = new LRUCache<
        string,
        LoaderData<APITypes.ResourceLifeAccessRight>
      >({
        max: MAX_CACHE_ITEMS,
      });
    }

    if (key) {
      const isDeleted = ResourceLifeLRUCache.cache.delete(key);
      return {
        success: isDeleted,
        data: ResourceLifeLRUCache.cache,
        error: isDeleted
          ? new Error(`error deleting ${key} from the auth cache`)
          : null,
      };
    }

    ResourceLifeLRUCache.cache.clear();
    return {
      success: true,
      data: ResourceLifeLRUCache.cache,
    };
  }
}
